module.exports = __webpack_public_path__ + "static/media/step5.3b0ccacc.webp";